import React from 'react'
import { Link, LinkProps, NavLink, NavLinkProps } from 'react-router-dom'
import { isExternalLink, isAnchorLink, isNonHttpLink } from 'common/helpers/link-utils'

export interface WebLinkProps extends LinkProps {
    openExternalInNewWindow?: boolean
}
export interface WebNavLinkProps extends NavLinkProps {
    openExternalInNewWindow?: boolean
}

/**
 * Wrapper around internal and external links
 * - internal links use react-router <Link>
 * - external links use <a> (absolute url or rel="external")
 */
export const WebLink: React.FC<WebLinkProps> = props => {
    const { to } = props
    const url = typeof to === 'string' && to
    const isExternalHttp = url && isExternalLink(url, props.rel)
    const isExternal = url && (isExternalHttp || isAnchorLink(url) || isNonHttpLink(url))
    if (isExternal) {
        // if you explicity mark a nav item as openExternalInNewWindow = false, it won't
        // matter if its an external link, it will stay within the window
        const target =
            (isExternalHttp && props.openExternalInNewWindow !== false) ||
            props.openExternalInNewWindow
                ? '_blank'
                : undefined
        const {
            openExternalInNewWindow: _,
            to: __,
            replace: ___,
            style: ____,
            ...justLinkProps
        } = props
        const aProps: React.AnchorHTMLAttributes<HTMLAnchorElement> = {
            ...justLinkProps,
            href: typeof props.to === 'string' ? props.to : props.to.pathname,
            target,
        }

        return <a {...aProps} />
    }

    const { openExternalInNewWindow, css, ...linkProps } = props

    return <Link {...linkProps} />
}
WebLink.displayName = 'WebLink'

/**
 * Wrapper around internal and external links
 * - internal links use react-router <Link>
 * - external links use <a> (absolute url or rel="external")
 */
export const WebNavLink: React.FC<WebNavLinkProps> = props => {
    const { to } = props
    const url = typeof to === 'string' && to
    const isExternal = url && (isExternalLink(url, props.rel) || isNonHttpLink(url))
    if (isExternal) {
        const target = props.openExternalInNewWindow ? '_blank' : undefined
        const {
            openExternalInNewWindow: _,
            to: __,
            replace: ___,
            style: ____,
            activeClassName: _____,
            isActive: ______,
            ...justLinkProps
        } = props

        const aProps = {
            ...justLinkProps,
            href: typeof props.to === 'string' ? props.to : props.to.pathname,
            target,
        }

        return <a {...aProps} />
    }

    const { openExternalInNewWindow, css, ...linkProps } = props

    return <NavLink {...linkProps} />
}
WebNavLink.displayName = 'WebNavLink'
